import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import LookVideoDialog from '@/components/look-video-dialog.vue';
import TextbookList from '@/components/textbook-list.vue';
import NoFindZxb from '@/components/no-find-zxb.vue';
import DarkBg from '@/components/dark-bg.vue'; // import InputCode from '@/components/input-code.vue'

import TopicModel from '@/components/topic-video-dialog.vue';
import { getCodeUrlMixins } from '@/utils/getCodeUrlMixin.js';
import { getVideoUrl } from '@/utils/guide-video';
import { guideQuery } from '@/api/modules/guide.js';
export default {
  name: 'HomeViewRecord',
  components: {
    DarkBg: DarkBg,
    // InputCode,
    TextbookList: TextbookList,
    TopicModel: TopicModel,
    LookVideoDialog: LookVideoDialog
  },
  mixins: [getCodeUrlMixins],
  props: {
    showMoreBtn: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    recordList: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      topicVisible: false,
      iframeTitle: '',
      iframeUrl: '',
      iframeResult: '',
      code: '',
      video: {
        show: false,
        url: '',
        title: ''
      },
      preciousName: '',
      selectTextbook: false
    };
  },
  computed: _objectSpread({}, mapGetters(['preciousMessage'])),
  watch: {
    code: function code(val) {
      this.code = val.replace(/[^0-9]/g, '');
    }
  },
  methods: {
    changePreciousListStatus: function changePreciousListStatus() {
      this.selectTextbook = false;
    },
    searchCode: function searchCode() {
      if (!this.code) {
        this.$message.error('请输入页码后，再进行检索');
        return;
      }

      this.handleShowiframeDialog(_objectSpread({
        page: this.code
      }, this.preciousMessage));
    },
    setPreciousName: function setPreciousName(name) {
      // 弹框点击确定关闭后把最新的名字传出来
      this.preciousName = name;
    },
    handleShowiframeDialog: function handleShowiframeDialog() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var topic, params, _yield$_this$getCodeT, result;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                topic = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                _this.code = (topic.turnPage || topic.page) + '';
                params = {
                  page: _this.code,
                  subject: topic.subjectId || topic.subject,
                  boxId: topic.boxId,
                  preciousType: topic.subPreciousType || topic.preciousType,
                  historyId: topic.id,
                  obtainMethod: topic.id ? 4 : 1 // 历史记录传4，首页左侧输入框传1

                };

                if (topic.id) {
                  // 历史记录练习宝前端存值判断要不要显示tab
                  sessionStorage.preciousType = params.preciousType;
                }

                _context.next = 6;
                return _this.getCodeTurn(params);

              case 6:
                _yield$_this$getCodeT = _context.sent;
                result = _yield$_this$getCodeT.result;
                _this.code = '';

                if (result) {
                  _context.next = 12;
                  break;
                }

                _this.$showModal(NoFindZxb, {}, {
                  noFooter: true,
                  width: '784px',
                  customClass: 'no-find-dialog'
                });

                return _context.abrupt("return");

              case 12:
                _this.iframeResult = result;
                _this.iframeTitle = result.outlineName;
                _this.topicVisible = !_this.topicVisible;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getMore: function getMore() {
      !this.isLoading && this.$emit('getMore');
    },
    // 播放视频
    playVideo: function playVideo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$;

        var params, _yield$guideQuery, data, video, url, title;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  codes: ['V0003']
                };
                _context2.next = 3;
                return guideQuery(params);

              case 3:
                _yield$guideQuery = _context2.sent;
                data = _yield$guideQuery.data;
                video = JSON.parse((_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.content);
                url = getVideoUrl(video);
                title = video.videoName;
                _this2.video = {
                  show: true,
                  url: url,
                  title: title
                };

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};